export const colors = {
  black: "#000",
  blue: "#007BFF",
  green: "#00ac33",
  pix: "#32bcad",
  red: "#FF000F",
  white: "#fff",

  yellowGreen: {
    100: "#e6fc8b",
    500: "#FCEA51",
    600: "#a7d33b",
    700: "#789b22",
  },

  gray: {
    50: "#f7f7f7",
    100: "#e7e7e7",
    200: "#d9d9d9",
    400: "#a9a9a9",
    500: "#888888",
    600: "#CBCBCB",
    700: "#393939",
    900: "#1d1d1b",
  },

  darkGray: {
    400: "#6e757a",
    500: "#4b5258",
    600: "#32373a",
  },

  cripten: {
    lightYellow: "#FCEA51",
    darkYellow: "#F7B119",
    brown: "#302D1A",
  },
};

export const hexToRGBA = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha || 1})`;
};
